// *********************
// Actions
// *********************

// import { CallServiceFromServerEvent } from '../modules/websocket/type';

export declare type Actions = ResetStateAction | SetStateAction;

export type ResetStateAction = {
    type: 'RESET_STATE';
    path?: string;
};

export type SetStateAction = {
    type: 'SET_STATE';
    path: string;
    value: any;
};

// *********************
// Caching
// *********************

export const CACHING_KEY = 'DEFAULT_CACHING';

export const CACHING_EMPTY_STRING = '{}';

// *********************
// State
// *********************

export declare type States = {
    // $ 语言
    language: string;
    // 全局加载条(线性)
    globalLoading: { value: boolean, action: boolean };
    // 全局加载条(转圈)
    backdropLoading: boolean;
    // 全局加载条进度
    backdropLoadingValue: number;
};

export const INIT_STATE: States = {
    // $ 语言
    language: 'EN',
    // 全局加载条(线性)
    globalLoading: { value: false, action: false },
    // 全局加载条(转圈)
    backdropLoading: false,
    // 全局加载条进度
    backdropLoadingValue: 0,
}
